module.exports = __webpack_public_path__ + "static/contact-c0548c3689209f9e7929cf8a215dff62.png";